function addToCartWizard() {
  const storageKey = `dunks-kit-state:${window.location.pathname}`;
  return {
    step: 1,
    steps: ["Dunks", "Spud Dust", "Shake Bags", "Tub"],
    subscribeAndSave: false,
    deliveryFrequency: "monthly",
    bagsCount: 1,
    crispAllergen: `<div class=has-motion><div class="cf rte"><p><meta charset=utf-8><meta charset=utf-8><strong data-mce-fragment=1>Dunks Nutritional Information</strong><br><div class=nutrition_information><table style=height:211.938px;width:98.2124% width=474><tr style=height:19.5938px><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 25g Serving</strong><tr style=height:39.1875px><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1838 kJ<br>437 kcal<td style=width:208.953px>459.5 kJ<br>109.25 kcal<br><tr style=height:19.5938px><td style=width:192px><strong>Fat</strong><td style=width:128.047px>13.2g<br><td style=width:208.953px>3.3g<br><tr style=height:19.5938px><td style=width:192px>    Saturated<td style=width:128.047px>1.0g<br><td style=width:208.953px>0.25g<br><tr style=height:19.5938px><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px>74.9g<br><td style=width:208.953px>18.73g<br><tr style=height:19.5938px><td style=width:192px>    Sugars<td style=width:128.047px>0.2g<br><td style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt;0.1g</span><br><tr style=height:19.5938px><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>3.5g<br><td style=width:208.953px>0.88g<br><tr style=height:19.5938px><td style=width:192px><strong>Protein</strong><td style=width:128.047px>2.9g<br><td style=width:208.953px>0.73g<br><tr style=height:35.5938px><td style=width:192px><strong>Salt</strong><td style=width:128.047px>2.91g<br><td style=width:208.953px>0.73g<br></table><strong>Ingredients<br></strong>Potato Starch, Potato Granuals, Rapeseed Oil, Pre-Gelatinised Potato Starch, Salt, Vegetable based distilled mono-glyceride.</div></div></div>`,
    bagPrice: 9.99,
    numberOf: 5,
    shakeBagsCount: 5,
    cartLoading: false,
    _scrollListenerAdded: false,
    flavorMode: null,
    flavorsSachets: [
      {
        id: 1,
        name: "Chip Shop Curry",
        link: "/collections/spud-dust/products/chip-shop-curry-spud-dust",
        blurb: "It's Chip Shop Curry sauce flavour without the attitude.",
        img: sachets[4],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1414 kJ<br>336 kcal<td style=width:208.953px>70.7 kJ<br>16.8 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8>3.04g<br><td style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8>0.45g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>65.6g<br><td style=width:208.953px><meta charset=utf-8>3.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>27.68g<br><td style=width:208.953px><meta charset=utf-8>1.4g<br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.21g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>8.14g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8>14.67g<br><td style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spices (cumin, coriander, turmeric, fennel, fenugreek, cayenne, black pepper), Sugar, Salt, Onion Powder, Yeast Extract, Garlic Powder, Maltodextrin, Tomato Powder, Paprika Extract.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 2,
        name: "Crispy Bacon",
        link: "/collections/spud-dust/products/david-bacon-spud-dust",
        blurb: "This isn't just any old bacon flavour, this is Crispy Bacon! ",
        img: sachets[5],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1380 kJ<br>328 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>69.01 kJ<br>16.4 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.62g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.24g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>75.76g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.8g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>20.01g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>4.68g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>15.12g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.8g<br></table></div><p><br><p><strong>Ingredients</strong><br>Salt, Yeast Extract, Spices (black pepper, cayenne, clove, pimento), Sugar, Flavouring, Paprika Extract, Maltodextrin, Dextrose, Spice Extract <br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 3,
        name: "Nduja & Honey",
        link: "/collections/spud-dust/products/nduja-honey",
        blurb: "Rich Italian salami with sweet and smooth honey.",
        img: sachets[7],
        count: 0,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table style=height:195.938px width=100%><tr style=height:19.5938px><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1322.5 kJ<br>331.9 kcal<td style=width:208.953px>66.1 kJ<br>16.6 kcal<br><tr style=height:19.5938px><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8> 3.43g<br><td style=width:208.953px><meta charset=utf-8> 0.17g<br><tr style=height:19.5938px><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8> 0.64g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr style=height:19.5938px><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>57.4g<br><td style=width:208.953px><meta charset=utf-8>2.87g<br><tr style=height:19.5938px><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>44.2g<br><td style=width:208.953px><meta charset=utf-8>2.21g<br><tr style=height:19.5938px><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8> 7.20g<br><td style=width:208.953px><meta charset=utf-8> 0.36g<br><tr style=height:19.5938px><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>10g<br><td style=width:208.953px><meta charset=utf-8> 0.5g<br><tr style=height:19.5938px><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8> 17.7g<br><td style=width:208.953px><meta charset=utf-8> 0.88g<br></table></div><p><br><p><strong>Ingredients</strong><br><meta charset=utf-8><span dir=ltr role=presentation>Spices (Cayenne, Paprika), Sugar, Dextrose, Salt, Yeast Extract, Icing Sugar, Garlic </span><span dir=ltr role=presentation>Powder, Natural Flavouring, </span><span dir=ltr role=presentation>Acid E330, Paprika Extract, Spice Extract.</span><span dir=ltr role=presentation></span><br><p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 4,
        name: "Nooch & Onion",
        link: "/collections/spud-dust/products/nooch-onion-spud-dust",
        blurb: `Nooch has a nutty cheese flavour, but it's jam packed with nutrients.`,
        img: sachets[6],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1370 kJ<br>326 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>68.5 kJ<br>16.3 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.26g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.27g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>72.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.6g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>13.84g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>1.86g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>7.44g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>14.69g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Yeast Extract, Onion Powder (<strong>sulphites</strong>), Sugar (<strong>sulphites</strong>), Paprika Extract, Maltodextrin (<strong>sulphites</strong>), Salt, Natural Flavouring.<br><p><strong>Allergies</strong><br>In bold.<br><p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 5,
        name: "Pickled Gherkin",
        link: "/collections/spud-dust/products/pickled-gherkin",
        blurb: "Pickle lovers unite! You know who you are.",
        img: sachets[1],
        count: 0,
        allergen: `<div class=" has-motion"><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1151 kJ<br>274 kcal<td style=width:208.953px;height:39.1875px>57.55 kJ<br>13.7 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>3.46g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>0.17g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.36g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>50.50g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.52g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>21.39g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.07g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>6.12g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.31g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>7.15g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.36g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.78g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Pickled Gherkin </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Sugar, Spirit Vinegar Powder, Spices (Dill, Cayenne, Caraway, Coriander, Fennel), Salt, Acid E330, Yeast Extract, Garlic Powder, Onion Powder, Herbs (Parsley), Natural Flavouring.<br><p><strong><span><meta charset=utf-8>Pickled Gherkin </span>Spud Dust Allergens in Bold.</strong><br><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 6,
        name: "Prawn Cocktail",
        link: "/collections/spud-dust/products/prawn-cocktail-spud-dust",
        blurb:
          "The subtlety of prawn and the traditional posh dusting of paprika.",
        img: sachets[3],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1078 kJ<br>257 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>53.9 kJ<br>12.8 kcal<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1.21g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.17g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>53.76.6g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>2.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>34.29g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>2.30g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>6.52g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.3g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>17.75g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.9g<br></table></div><p><br><p><strong>Ingredients<br></strong>Rice Flour, Sugar, Salt, Dextrose, Acidity Regulator E262(ii), Yeast Extract, Acid E330, Onion Powder, Icing Sugar, Tomato Powder, Spices (Cayenne), Natural Flavouring, Paprika Extract, Spice Extract<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 7,
        name: "Salt & Vinegar",
        link: "/collections/spud-dust/products/salt-vinegar-spud-dust",
        blurb: "An absolute classic.",
        img: sachets[2],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1190 kJ<br>283 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>59.5 kJ<br>14.2 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.03g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px>0g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>60.91g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>3g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>9.33g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.5g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>0.16g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.07g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>21.51g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>1.1g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spirit Vinegar, Salt, Yeast Extract, Maltodextrin, Citric Acid, Sugar.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 8,
        name: "Southern Fried Chicken",
        link: "/collections/spud-dust/products/southern-fried-chicken-spud-dust",
        blurb: "The perfect blend of secret spices!",
        img: sachets[0],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr style=height:19px><td style=width:192px;height:19px><strong>Average</strong><td style=width:128.047px;height:19px><strong>Per 100g</strong><td style=width:208.953px;height:19px><strong>Per 5g Serving</strong><tr style=height:39px><td style=width:192px;height:39px><strong>Energy</strong><td style=width:128.047px;height:39px>1233 kJ<br>293 kcal<td style=width:208.953px;height:39px>61.65 kJ<br>14.654 kcal<br><tr style=height:19px><td style=width:192px;height:19px><strong>Fat</strong><td style=width:128.047px;height:19px>1.74g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px>    Saturated<td style=width:128.047px;height:19px><meta charset=utf-8>0.47g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19px>51.39g<br><td style=width:208.953px;height:19px><meta charset=utf-8>2.56g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>3.47g<br><td style=width:208.953px><meta charset=utf-8>0.17g<br><tr><td style=width:192px>    Starch<td style=width:128.047px>1.14g<td style=width:208.953px><meta charset=utf-8><span>&lt; 0.1g</span><tr style=height:19px><td style=width:192px;height:19px><strong>Fibre</strong><td style=width:128.047px;height:19px>8.07g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.40g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Protein</strong><td style=width:128.047px;height:19px><meta charset=utf-8>14.09g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.70g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Salt</strong><td style=width:128.047px;height:19px>16.38g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.81g<br></table></div><p><br><p><strong>Ingredients</strong><br>Rice Flour, Yeast Extract, Onion Powder, Spices (Black Pepper, Paprika, Mace, Fennel, Ginger), Salt, Garlic Powder, Herbs (Oregano, Thyme), Spice Extract<br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
    ],
    flavorsShakers: [
      {
        id: 1,
        name: "Beef Bourguignon",
        link: "/collections/spud-dust/products/beef-bourguignon",
        blurb:
          "The incredible tasting notes of steak, mushrooms and red wine. ",
        img: shakers[0],
        count: 0,
        itemId: 57754722206083,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1177 kJ<br>280 kcal<td style=width:208.953px;height:39.1875px>58.85 kJ<br>14 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>0.82g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.2g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>51.58g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.58g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>20.26g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.01g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>4.07g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.2g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>14.63g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.73g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.82g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Beef Bourguignon </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Yeast Extract, Salt, Mushroom Extract Powder, Sugar, Balsamic Vinegar Powder, Garlic Powder, Onion Powder, Spirit Vinegar Powder, Caramelised Sugar Powder, Red Beetroot Powder, Herbs (Parsley, Thyme), Spices (Black Pepper), Acid E330, Natural Flavouring.<br><p><strong><span>Beef Bourguignon </span>Spud Dust Allergens in Bold.</strong><br><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 2,
        name: "Chip Shop Curry",
        link: "/collections/spud-dust/products/chip-shop-curry-spud-dust",
        blurb: "It's Chip Shop Curry sauce flavour without the attitude.",
        img: shakers[5],
        count: 0,
        itemId: 43968361103615,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1414 kJ<br>336 kcal<td style=width:208.953px>70.7 kJ<br>16.8 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8>3.04g<br><td style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8>0.45g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>65.6g<br><td style=width:208.953px><meta charset=utf-8>3.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>27.68g<br><td style=width:208.953px><meta charset=utf-8>1.4g<br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.21g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>8.14g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8>14.67g<br><td style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spices (cumin, coriander, turmeric, fennel, fenugreek, cayenne, black pepper), Sugar, Salt, Onion Powder, Yeast Extract, Garlic Powder, Maltodextrin, Tomato Powder, Paprika Extract.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 3,
        name: "Crispy Bacon",
        link: "/collections/spud-dust/products/david-bacon-spud-dust",
        blurb: "This isn't just any old bacon flavour, this is Crispy Bacon! ",
        img: shakers[6],
        count: 0,
        itemId: 42295222272255,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1380 kJ<br>328 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>69.01 kJ<br>16.4 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.62g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.24g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>75.76g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.8g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>20.01g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>4.68g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>15.12g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.8g<br></table></div><p><br><p><strong>Ingredients</strong><br>Salt, Yeast Extract, Spices (black pepper, cayenne, clove, pimento), Sugar, Flavouring, Paprika Extract, Maltodextrin, Dextrose, Spice Extract <br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 4,
        name: "Nduja & Honey",
        link: "/collections/spud-dust/products/nduja-honey",
        blurb: "Rich Italian salami with sweet and smooth honey.",
        img: shakers[8],
        count: 0,
        itemId: 46066337218815,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table style=height:195.938px width=100%><tr style=height:19.5938px><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1322.5 kJ<br>331.9 kcal<td style=width:208.953px>66.1 kJ<br>16.6 kcal<br><tr style=height:19.5938px><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8> 3.43g<br><td style=width:208.953px><meta charset=utf-8> 0.17g<br><tr style=height:19.5938px><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8> 0.64g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr style=height:19.5938px><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>57.4g<br><td style=width:208.953px><meta charset=utf-8>2.87g<br><tr style=height:19.5938px><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>44.2g<br><td style=width:208.953px><meta charset=utf-8>2.21g<br><tr style=height:19.5938px><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8> 7.20g<br><td style=width:208.953px><meta charset=utf-8> 0.36g<br><tr style=height:19.5938px><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>10g<br><td style=width:208.953px><meta charset=utf-8> 0.5g<br><tr style=height:19.5938px><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8> 17.7g<br><td style=width:208.953px><meta charset=utf-8> 0.88g<br></table></div><p><br><p><strong>Ingredients</strong><br><meta charset=utf-8><span dir=ltr role=presentation>Spices (Cayenne, Paprika), Sugar, Dextrose, Salt, Yeast Extract, Icing Sugar, Garlic </span><span dir=ltr role=presentation>Powder, Natural Flavouring, </span><span dir=ltr role=presentation>Acid E330, Paprika Extract, Spice Extract.</span><span dir=ltr role=presentation></span><br><p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 5,
        name: "Nooch & Onion",
        link: "/collections/spud-dust/products/nooch-onion-spud-dust",
        blurb: `Nooch has a nutty cheese flavour, but it's jam packed with nutrients.`,
        img: shakers[7],
        count: 0,
        itemId: 42295226630399,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1370 kJ<br>326 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>68.5 kJ<br>16.3 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.26g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.27g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>72.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.6g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>13.84g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>1.86g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>7.44g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>14.69g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Yeast Extract, Onion Powder (<strong>sulphites</strong>), Sugar (<strong>sulphites</strong>), Paprika Extract, Maltodextrin (<strong>sulphites</strong>), Salt, Natural Flavouring.<br><p><strong>Allergies</strong><br>In bold.<br><p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 6,
        name: "Pickled Gherkin",
        link: "/collections/spud-dust/products/pickled-gherkin",
        blurb: "Pickle lovers unite! You know who you are.",
        img: shakers[10],
        count: 0,
        itemId: 56889545884035,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1151 kJ<br>274 kcal<td style=width:208.953px;height:39.1875px>57.55 kJ<br>13.7 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>3.46g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>0.17g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.36g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>50.50g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.52g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>21.39g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.07g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>6.12g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.31g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>7.15g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.36g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.78g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Pickled Gherkin </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Sugar, Spirit Vinegar Powder, Spices (Dill, Cayenne, Caraway, Coriander, Fennel), Salt, Acid E330, Yeast Extract, Garlic Powder, Onion Powder, Herbs (Parsley), Natural Flavouring.<br><p><strong><span><meta charset=utf-8>Pickled Gherkin </span>Spud Dust Allergens in Bold.</strong><br><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 7,
        name: "Prawn Cocktail",
        link: "/collections/spud-dust/products/prawn-cocktail-spud-dust",
        blurb:
          "The subtlety of prawn and the traditional posh dusting of paprika.",
        img: shakers[4],
        count: 0,
        itemId: 43718375112959,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1078 kJ<br>257 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>53.9 kJ<br>12.8 kcal<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1.21g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.17g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>53.76.6g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>2.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>34.29g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>2.30g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>6.52g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.3g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>17.75g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.9g<br></table></div><p><br><p><strong>Ingredients<br></strong>Rice Flour, Sugar, Salt, Dextrose, Acidity Regulator E262(ii), Yeast Extract, Acid E330, Onion Powder, Icing Sugar, Tomato Powder, Spices (Cayenne), Natural Flavouring, Paprika Extract, Spice Extract<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 8,
        name: "Salt & Vinegar",
        link: "/collections/spud-dust/products/salt-vinegar-spud-dust",
        blurb: "An absolute classic.",
        img: shakers[3],
        count: 0,
        itemId: 42295228694783,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1190 kJ<br>283 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>59.5 kJ<br>14.2 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.03g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px>0g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>60.91g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>3g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>9.33g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.5g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>0.16g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.07g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>21.51g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>1.1g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spirit Vinegar, Salt, Yeast Extract, Maltodextrin, Citric Acid, Sugar.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 9,
        name: "Southern Fried Chicken",
        link: "/collections/spud-dust/products/southern-fried-chicken-spud-dust",
        blurb: "The perfect blend of secret spices!",
        img: shakers[1],
        count: 0,
        itemId: 44364244713727,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr style=height:19px><td style=width:192px;height:19px><strong>Average</strong><td style=width:128.047px;height:19px><strong>Per 100g</strong><td style=width:208.953px;height:19px><strong>Per 5g Serving</strong><tr style=height:39px><td style=width:192px;height:39px><strong>Energy</strong><td style=width:128.047px;height:39px>1233 kJ<br>293 kcal<td style=width:208.953px;height:39px>61.65 kJ<br>14.654 kcal<br><tr style=height:19px><td style=width:192px;height:19px><strong>Fat</strong><td style=width:128.047px;height:19px>1.74g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px>    Saturated<td style=width:128.047px;height:19px><meta charset=utf-8>0.47g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19px>51.39g<br><td style=width:208.953px;height:19px><meta charset=utf-8>2.56g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>3.47g<br><td style=width:208.953px><meta charset=utf-8>0.17g<br><tr><td style=width:192px>    Starch<td style=width:128.047px>1.14g<td style=width:208.953px><meta charset=utf-8><span>&lt; 0.1g</span><tr style=height:19px><td style=width:192px;height:19px><strong>Fibre</strong><td style=width:128.047px;height:19px>8.07g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.40g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Protein</strong><td style=width:128.047px;height:19px><meta charset=utf-8>14.09g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.70g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Salt</strong><td style=width:128.047px;height:19px>16.38g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.81g<br></table></div><p><br><p><strong>Ingredients</strong><br>Rice Flour, Yeast Extract, Onion Powder, Spices (Black Pepper, Paprika, Mace, Fennel, Ginger), Salt, Garlic Powder, Herbs (Oregano, Thyme), Spice Extract<br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 10,
        name: "Vindaloo",
        link: "/collections/spud-dust/products/vindaloo-spud-dust",
        blurb: "It's smokey, meaty and very very spicy.",
        img: shakers[9],
        count: 0,
        itemId: 56630240969091,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutritional Information</strong><table style=height:215.532px width=100%><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Average</strong><td style=width:128.047px;height:19.5938px><strong>Per 100g</strong><td style=width:208.953px;height:19.5938px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px;height:39.1875px><strong>Energy</strong><td style=width:128.047px;height:39.1875px>1253 kJ<br>298 kcal<td style=width:208.953px;height:39.1875px>62.65 kJ<br>14.9 kcal<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fat</strong><td style=width:128.047px;height:19.5938px>2.51g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>0.12g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Saturated<td style=width:128.047px;height:19.5938px><meta charset=utf-8>0.47g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8><span>&lt; 0.1g</span><br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19.5938px>51.88g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>2.59g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px>    Sugars<td style=width:128.047px;height:19.5938px><meta charset=utf-8>23.68g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>1.18g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Fibre</strong><td style=width:128.047px;height:19.5938px>10.96g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.55g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Protein</strong><td style=width:128.047px;height:19.5938px><meta charset=utf-8>11.48g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.58g<br><tr style=height:19.5938px><td style=width:192px;height:19.5938px><strong>Salt</strong><td style=width:128.047px;height:19.5938px>17.89g<br><td style=width:208.953px;height:19.5938px><meta charset=utf-8>0.89g</table><p> <br><strong><span>Vindaloo </span>Spud Dust <meta charset=utf-8>Ingredients<br></strong>Tomato Powder, Salt, Spices (Ginger, Coriander, Cardamom, Cumin, Paprika, Turmeric) (<strong>SULPHITES</strong>), Onion Powder (<strong>SULPHITES</strong>), Sugar (<strong>SULPHITES</strong>), Garlic Powder (<strong>SULPHITES</strong>), Curry Powder (Spices Coriander, Fenugreek, Turmeric, Cayenne, Cumin, Black Pepper, Paprika), Rice Flour, Salt, Potato Starch, Whole Caraway Seed, Whole Fennel Seed, Garlic Powder, Onion Powder (<strong>SULPHITES</strong>), Yeast Extract, Spirit Vinegar Powder, Ghost Chilli Powder / Naga Chilli Powder, Acid E330, Paprika Extract, Natural Flavouring.<br><p><strong><span>Vindaloo </span>Spud Dust Allergens in Bold.</strong><br><span>Sulphites.</span><p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
    ],
    flavors: null,
    additionalShakers: [],
    selectedFlavors: [],
    tub: 0,
    tubPrice: 4.99,
    shakerPrice: 3.99,
    shakerDiscountedPrice: 3.6,
    swiperInstance: null,
    modalHeader: null,
    modalText: null,
    modalClose: null,
    modalContinue: null,
    modalOpen: false,
    allergensContent: "",

    canUseStorage() {
      try {
        return typeof window.localStorage !== "undefined";
      } catch (error) {
        return false;
      }
    },

    persistState(state = this.getState()) {
      if (!this.canUseStorage()) {
        return;
      }

      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {
        console.error("Error saving dunks kit state:", error);
      }
    },

    getPersistedState() {
      if (!this.canUseStorage()) {
        return null;
      }

      try {
        const savedState = window.localStorage.getItem(storageKey);

        if (!savedState) {
          return null;
        }

        return JSON.parse(savedState);
      } catch (error) {
        console.error("Error reading dunks kit state:", error);
        return null;
      }
    },

    clearPersistedState() {
      if (!this.canUseStorage()) {
        return;
      }

      try {
        window.localStorage.removeItem(storageKey);
      } catch (error) {
        console.error("Error clearing dunks kit state:", error);
      }
    },

    applyState(state = {}) {
      this.step = state.step ?? 1;
      this.bagsCount = state.bagsCount ?? 1;
      this.numberOf = 5 * this.bagsCount;
      this.shakeBagsCount = Math.min(
        state.shakeBagsCount ?? this.numberOf,
        this.numberOf,
      );
      this.tub = Math.min(state.tub ?? 0, this.bagsCount);

      const savedSachets = state.selectedSachets ?? state.selectedFlavors ?? [];
      const savedShakers = state.selectedShakers ?? [];

      let sachetsTotal = 0;
      this.flavorsSachets.forEach((flavor) => {
        const savedFlavor = savedSachets.find((f) => f.id === flavor.id);
        if (savedFlavor) {
          if (sachetsTotal + savedFlavor.count > this.numberOf) {
            flavor.count = Math.max(0, this.numberOf - sachetsTotal);
          } else {
            flavor.count = savedFlavor.count;
          }
          sachetsTotal += flavor.count;
        } else {
          flavor.count = 0;
        }
      });

      this.flavorsShakers.forEach((flavor) => {
        const savedFlavor = savedShakers.find((f) => f.id === flavor.id);
        flavor.count = savedFlavor
          ? Math.max(0, Number(savedFlavor.count) || 0)
          : 0;
      });

      const savedAdditionalShakers = state.additionalShakers ?? [];
      this.additionalShakers = this.flavorsShakers.map((flavor) => {
        const savedAdditional = savedAdditionalShakers.find(
          (f) => f.id === flavor.id,
        );
        return {
          id: flavor.id,
          count: Math.max(0, Number(savedAdditional?.count) || 0),
          itemId: flavor.itemId,
        };
      });

      const requestedFlavorMode =
        state.flavorMode === "shakers"
          ? "shakers"
          : state.flavorMode === "sachets"
            ? "sachets"
            : null;
      this.flavorMode = requestedFlavorMode;
      this.flavors =
        requestedFlavorMode === "shakers"
          ? this.flavorsShakers
          : requestedFlavorMode === "sachets"
            ? this.flavorsSachets
            : null;

      this.shakeBagsCount = Math.min(this.shakeBagsCount, this.numberOf);
      this.tub = Math.min(this.tub, this.bagsCount);
    },

    syncState({ method = "replace" } = {}) {
      const state = this.getState();
      const nextUrl = new URL(window.location);
      nextUrl.searchParams.set("step", state.step);

      if (method === "push") {
        history.pushState(state, "", nextUrl);
      } else {
        history.replaceState(state, "", nextUrl);
      }

      this.persistState(state);
    },

    init() {
      const url = new URL(window.location);
      const historyState = window.history.state;
      const persistedState = this.getPersistedState();
      const hasHistoryStep = Boolean(historyState?.step);

      if (hasHistoryStep) {
        this.applyState(historyState);
      } else {
        if (persistedState) {
          this.applyState(persistedState);
        }

        // New entries to the page always restart the flow at step 1,
        // while keeping previously selected products/counts.
        this.step = 1;
        if (!this.subscribeAndSave) {
          this.flavorMode = null;
          this.flavors = null;
        }
      }

      if (url.searchParams.has("step") || persistedState || hasHistoryStep) {
        this.syncState();
      } else if (this.step === 1 && !url.searchParams.has("step")) {
        this.syncState();
      }

      if (
        !hasHistoryStep &&
        !persistedState &&
        url.searchParams.has("subscribe")
      ) {
        if (url.searchParams.get("subscribe") === "1") {
          this.deliveryFrequency = "twomonths";
        }
        if (url.searchParams.get("subscribe") === "2") {
          this.deliveryFrequency = "monthly";
        }
        if (url.searchParams.get("subscribe") === "3") {
          this.deliveryFrequency = "biweekly";
        }
        this.subscribeAndSave = true;
        this.setSachets({ sync: false });
        this.syncState();
      }

      setTimeout(() => {
        this.initSwiper();
        this.onScrollFlavors();
        this.onScrollNextButton();

        if (this.step === 1) {
          document
            .querySelector(".crisp-kit")
            .classList.add("crisp-kit--step-1");
        }
        if (this.step !== 1) {
          document
            .querySelector(".crisp-kit")
            .classList.remove("crisp-kit--step-1");
        }

        window.addEventListener("resize", this.onResize.bind(this));
        window.scrollTo(0, 0);
      }, 0);

      window.addEventListener("popstate", (event) => {
        if (event.state) {
          this.applyState(event.state);
          this.persistState(event.state);
        }
      });
    },

    getState() {
      const state = {
        step: this.step,
        bagsCount: this.bagsCount,
        shakeBagsCount: this.shakeBagsCount,
        tub: this.tub,
        flavorMode: this.flavorMode,
        selectedSachets: this.flavorsSachets.map((flavor) => ({
          id: flavor.id,
          count: flavor.count,
        })),
        selectedShakers: this.flavorsShakers.map((flavor) => ({
          id: flavor.id,
          count: flavor.count,
        })),
        additionalShakers: this.additionalShakers.map((flavor) => ({
          id: flavor.id,
          count: flavor.count,
        })),
        selectedFlavors: this.flavorsSachets.map((flavor) => ({
          id: flavor.id,
          count: flavor.count,
        })),
      };
      return state;
    },

    updateState() {
      this.syncState({ method: "push" });
    },

    onResize() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
      this.initSwiper();
    },

    destroy() {
      window.removeEventListener("resize", this.onResize.bind(this));
    },

    waitForImagesToLoad(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) {
        return Promise.resolve();
      }

      const images = container.querySelectorAll("img");
      const imagePromises = Array.from(images).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.addEventListener("load", resolve);
            img.addEventListener("error", resolve);
          }
        });
      });

      return Promise.all(imagePromises);
    },

    prepareFlavorGallery(event, imageUrl) {
      const mediaGallery = event.currentTarget.closest("media-gallery");
      const galleryModal = mediaGallery?.galleryModal;
      if (!galleryModal) return;

      const thumbsContainer = galleryModal.querySelector(".gallery-viewer__thumbs");
      if (!thumbsContainer) return;

      // Collect unique images from the swiper, excluding Swiper loop clones
      const swiper = mediaGallery.closest(".swiper");
      const allUrls = swiper
        ? [
            ...new Set(
              Array.from(
                swiper.querySelectorAll(
                  ".swiper-slide:not(.swiper-slide-duplicate) a.show-gallery",
                ),
              )
                .map((a) => a.getAttribute("href"))
                .filter(Boolean),
            ),
          ]
        : [imageUrl];

      thumbsContainer.innerHTML = allUrls
        .map(
          (url) =>
            `<a class="gallery-viewer__thumb" href="${url}" data-zoom-url="${url}">` +
            `<img class="gallery-viewer__thumb-img" src="${url}"></a>`,
        )
        .join("");

      // Add prev/next nav before first DOM append so connectedCallback finds them
      const controls = galleryModal.querySelector(".gallery-viewer__controls");
      if (controls && !controls.querySelector(".gallery-viewer__prev")) {
        controls.insertAdjacentHTML(
          "afterbegin",
          `<a class="gallery-viewer__button gallery-viewer__prev has-ltr-icon" href="#"><span class="visually-hidden">Previous</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-left" aria-hidden="true" focusable="false" role="presentation"><path d="m15 18-6-6 6-6"/></svg></a>` +
          `<a class="gallery-viewer__button gallery-viewer__next has-ltr-icon" href="#"><span class="visually-hidden">Next</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation"><path d="m9 18 6-6-6-6"/></svg></a>`,
        );
      }

      // Hide nav for single-image contexts (flavor option items)
      const galleryViewer = galleryModal.querySelector("gallery-viewer");
      if (galleryViewer) {
        galleryViewer.classList.toggle(
          "gallery-viewer--single-image",
          allUrls.length <= 1,
        );
      }

      // Add swipe-to-navigate once per modal
      if (!galleryModal.dataset.swipeEnabled) {
        galleryModal.dataset.swipeEnabled = "1";
        let swipeStartX = 0;
        let swipeStartY = 0;
        galleryModal.addEventListener(
          "touchstart",
          (e) => {
            if (e.touches.length === 1) {
              swipeStartX = e.touches[0].clientX;
              swipeStartY = e.touches[0].clientY;
            }
          },
          { passive: true },
        );
        galleryModal.addEventListener(
          "touchend",
          (e) => {
            if (e.changedTouches.length !== 1) return;
            const dx = e.changedTouches[0].clientX - swipeStartX;
            const dy = e.changedTouches[0].clientY - swipeStartY;
            if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
            const viewer = galleryModal.querySelector("gallery-viewer");
            if (dx < 0) viewer?.selectNextThumb();
            else viewer?.selectPreviousThumb();
          },
          { passive: true },
        );
      }
    },

    initSwiper() {
      const swiperElement = document.querySelector(".swiper");
      if (!swiperElement || swiperElement.offsetParent === null) {
        return;
      }

      this.waitForImagesToLoad(".swiper").then(() => {
        const slides = swiperElement.querySelectorAll(".swiper-slide");
        if (slides.length === 0) {
          return;
        }

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }

        if (slides.length === 1) {
          swiperElement.style.padding = "0 0 0 0";
        }

        this.swiperInstance = new Swiper(".swiper", {
          loop: slides.length > 1,
          autoHeight: true,
          pagination: {
            el: ".swiper-pagination",
          },
        });
      });
      document.querySelector(".crisp-kit").classList.add("is-flavor");
    },

    setSubscribeAndSave() {
      this.subscribeAndSave = !this.subscribeAndSave;
      if (this.subscribeAndSave) {
        this.setSachets({ sync: false });
        this.flavorsSachets.forEach((f) => {
          f.count = 0;
        });
        this.flavorsShakers.forEach((f) => {
          f.count = 0;
        });
      } else {
        this.flavorMode = null;
        this.flavors = null;
      }
      this.syncState();
      this.initSwiper();
    },

    setShakers({ sync = true } = {}) {
      if (this.subscribeAndSave) {
        this.setSachets({ sync });
        return;
      }
      this.flavorMode = "shakers";
      this.flavors = this.flavorsShakers;
      this.additionalShakers = this.flavorsShakers.map((f) => ({
        id: f.id,
        count: 0,
        itemId: f.itemId,
      }));
      if (sync) {
        this.syncState();
      }
      setTimeout(() => this.initSwiper(), 0);
    },

    setSachets({ sync = true } = {}) {
      this.flavorMode = "sachets";
      this.flavors = this.flavorsSachets;
      if (sync) {
        this.syncState();
      }
      setTimeout(() => this.initSwiper(), 0);
    },

    resetFlavorSelections() {
      this.flavorsSachets.forEach((f) => {
        f.count = 0;
      });
      this.flavorsShakers.forEach((f) => {
        f.count = 0;
      });
      this.additionalShakers = this.flavorsShakers.map((f) => ({
        id: f.id,
        count: 0,
        itemId: f.itemId,
      }));
      this.flavorMode = null;
      this.flavors = null;
    },

    nextStep() {
      if (this.step === 2) {
        if (!Array.isArray(this.flavors)) {
          this.modalHeader = "Select sachets or shakers.";
          this.modalText = "Please choose your Spud Dust format to continue.";
          this.modalClose = "OK";
          this.modalContinue = "";
          this.openModal();
          return;
        }

        if (this.flavors !== this.flavorsShakers) {
          if (this.getRemainingSelections() === this.numberOf) {
            this.modalHeader = "You've not selected any sachets.";
            this.modalText =
              "Are you sure you don't want any Spud Dust sachets?";
            this.modalClose = "Oops, pick sachets";
            this.modalContinue = "I'm good, move on";
            this.openModal();
            return;
          }
          if (
            this.getRemainingSelections() < this.numberOf &&
            this.getRemainingSelections() > 1
          ) {
            this.modalHeader =
              "You have " +
              this.getRemainingSelections() +
              " selections remaining";
            this.modalText =
              "Are you sure you don't want more Spud Dust sachets?";
            this.modalClose = "Oops, pick sachets";
            this.modalContinue = "I'm good, move on";
            this.openModal();
            return;
          }
        }
      }
      if (this.step === 3) {
        if (this.shakeBagsCount === 0) {
          this.modalHeader = "You’ve not selected any shake bags.";
          this.modalText = "Are you sure you don’t want any shake bags?";
          this.modalClose = "Oops, add bags";
          this.modalContinue = "I’m good, move on";
          this.openModal();
          return;
        }
      }
      this.step++;
      this.updateState();
      this.init();
    },

    setStep(step) {
      if (step != 5 && step > this.step) {
        return;
      }
      if (step === 1) {
        this.resetFlavorSelections();
      }
      this.step = step;
      this.updateState();
      this.init();
    },

    setBagsCount(count) {
      if (count >= 11) {
        return;
      }
      const oldBagsCount = this.bagsCount;
      this.bagsCount = count;
      this.numberOf = 5 * count;

      this.shakeBagsCount = this.numberOf;
      const normalizeSachetCounts = (flavors) => {
        let total = 0;
        flavors.forEach((flavor) => {
          if (total >= this.numberOf) {
            flavor.count = 0;
            return;
          }
          const allowed = this.numberOf - total;
          if (flavor.count > allowed) {
            flavor.count = allowed;
          }
          total += flavor.count;
        });
      };
      normalizeSachetCounts(this.flavorsSachets);

      if (this.shakeBagsCount > this.numberOf) {
        this.shakeBagsCount = this.numberOf * this.bagsCount;
      }

      if (this.tub > this.bagsCount) {
        this.tub = 0;
      }

      this.syncState();
    },

    onScrollFlavors() {
      const header = document.querySelector(
        ".crisp-kit-content-header-flavors",
      );
      if (header) {
        document.querySelector(".crisp-kit").classList.add("is-flavor");
      } else {
        if (document.querySelector(".is-flavor")) {
          document.querySelector(".crisp-kit").classList.remove("is-flavor");
          this.initSwiper();
        }
        return;
      }

      document.addEventListener("scroll", () => {
        const scrollTop = header.offsetTop - document.body.scrollTop;
        if (scrollTop > 254) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
      });
    },

    onScrollNextButton() {
      const nextStepContainer = document.querySelector(".next-step-container");
      if (!nextStepContainer) return;
      const checkSticky = () => {
        const rect = nextStepContainer.getBoundingClientRect();
        const isSticky = rect.bottom >= window.innerHeight;

        if (!isSticky) {
          nextStepContainer.classList.add("not-sticky");
        } else {
          nextStepContainer.classList.remove("not-sticky");
        }
      };
      checkSticky();
      window.addEventListener("scroll", checkSticky);
    },

    viewAllergens(id) {
      const flavor = this.flavorsSachets.find((f) => f.id === id);
      if (flavor && flavor.allergen) {
        this.modalHeader = flavor.name;
        this.modalText = flavor.allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    viewShakerAllergens(id) {
      const sachet = this.flavorsSachets.find((f) => f.id === id);
      if (sachet && sachet.allergen) {
        this.modalHeader = sachet.name;
        this.modalText = sachet.allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    crispAllergens() {
      const allergen = this.crispAllergen;
      if (allergen) {
        this.modalHeader = "Dunks";
        this.modalText = allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    increaseFlavor(id) {
      if (this.flavors === this.flavorsSachets) {
        const totalSelected = this.flavors.reduce((sum, f) => sum + f.count, 0);
        if (totalSelected >= this.numberOf) {
          return;
        }
      }
      const flavor = this.flavors
        ? this.flavors.find((f) => f.id === id)
        : null;
      if (flavor) flavor.count++;
      this.syncState();
    },

    decreaseFlavor(id) {
      const flavor = this.flavors
        ? this.flavors.find((f) => f.id === id)
        : null;
      if (flavor && flavor.count > 0) flavor.count--;
      this.syncState();
    },

    getFlavorCount(id) {
      const flavor = this.flavors
        ? this.flavors.find((f) => f.id === id)
        : null;
      return flavor ? flavor.count : 0;
    },

    getRemainingSelections() {
      if (!this.flavors) return this.numberOf;
      const totalSelected = this.flavors.reduce((sum, f) => sum + f.count, 0);
      return this.numberOf - totalSelected;
    },

    increaseAdditionalShaker(id) {
      const flavor = this.additionalShakers.find((f) => f.id === id);
      if (flavor) flavor.count++;
      this.syncState();
    },

    decreaseAdditionalShaker(id) {
      const flavor = this.additionalShakers.find((f) => f.id === id);
      if (flavor && flavor.count > 0) flavor.count--;
      this.syncState();
    },

    getAdditionalShakerCount(id) {
      const flavor = this.additionalShakers.find((f) => f.id === id);
      return flavor ? flavor.count : 0;
    },

    setShakeBagsCount(count) {
      this.shakeBagsCount = count;
      this.syncState();
    },

    setTub(count) {
      this.tub = count;
      if (count >= this.bagsCount) {
        return;
      }
      this.syncState();
    },

    openModal() {
      this.modalOpen = true;
      setTimeout(() => {
        const modalContent = document.querySelector(".modal-content");
        if (modalContent) {
          modalContent.scrollTop = 0;
        }
      }, 10);
    },

    closeModal() {
      this.modalOpen = false;
    },

    continueModal() {
      this.closeModal();
      this.step++;
      this.updateState();
      this.init();
    },

    getPrice() {
      let totalPrice = 0;
      let oldPrice = 0;

      totalPrice = this.bagPrice;
      if (this.bagsCount > 1) {
        totalPrice = (this.bagsCount - 1) * (this.bagPrice - 1) + this.bagPrice;
      }
      oldPrice = this.bagsCount * this.bagPrice;

      if (this.subscribeAndSave) {
        totalPrice *= 0.9;
      }

      if (this.flavorMode === "shakers") {
        const shakerCount = this.flavorsShakers.reduce(
          (sum, f) => sum + f.count,
          0,
        );
        if (shakerCount > 0) {
          totalPrice += shakerCount * this.shakerDiscountedPrice;
          oldPrice += shakerCount * this.shakerPrice;
        }
      }

      if (this.flavorMode === "sachets") {
        const additionalShakerCount = this.additionalShakers.reduce(
          (sum, f) => sum + f.count,
          0,
        );
        if (additionalShakerCount > 0) {
          const bundleCount = Math.floor(additionalShakerCount / 3);
          const singlesCount = additionalShakerCount % 3;
          const shakerPriceTotal =
            bundleCount * 10 + singlesCount * this.shakerPrice;
          totalPrice += shakerPriceTotal;
          oldPrice += additionalShakerCount * this.shakerPrice;
        }
      }

      if (this.tub > 0) {
        totalPrice += this.tub * this.tubPrice;
        oldPrice += this.tub * this.tubPrice;
      }

      if (oldPrice > totalPrice) {
        return (
          "<s>£" +
          oldPrice.toFixed(2) +
          "</s>&nbsp;<span>£" +
          totalPrice.toFixed(2) +
          "</span>"
        );
      }
      return "£" + totalPrice.toFixed(2);
    },

    addToCart() {
      const selectedSachets = this.flavorsSachets.filter((f) => f.count > 0);
      const selectedFlavorNames = selectedSachets.map(
        (f) => f.count + " " + f.name,
      );
      const selectedStepShakers =
        this.flavorMode === "shakers"
          ? this.flavorsShakers.filter((f) => f.count > 0)
          : [];

      const bagID =
        this.bagsCount === 1
          ? "56922362315139"
          : this.bagsCount === 2
            ? "56922362347907"
            : this.bagsCount === 3
              ? "56922362380675"
              : this.bagsCount === 4
                ? "56922362413443"
                : this.bagsCount === 5
                  ? "56922362446211"
                  : this.bagsCount === 6
                    ? "56922362478979"
                    : this.bagsCount === 7
                      ? "56922362511747"
                      : this.bagsCount === 8
                        ? "56922362544515"
                        : this.bagsCount === 9
                          ? "56922362577283"
                          : this.bagsCount === 10
                            ? "56922362610051"
                            : "";

      const items = [];

      items.push({
        id: bagID,
        quantity: 1,
        properties: {
          Shakebags:
            this.shakeBagsCount > 0 ? `Yes (${this.shakeBagsCount})` : "No",
          Sachets: selectedFlavorNames.join(", "),
        },
      });

      if (this.tub > 0) {
        items.push({ id: "42958480310527", quantity: this.tub });
      }

      selectedStepShakers.forEach((flavor) => {
        items.push({ id: String(flavor.itemId), quantity: flavor.count });
      });

      const selectedAdditionalShakers = this.additionalShakers
        .map((additionalFlavor) => {
          const flavorMeta = this.flavorsShakers.find(
            (flavor) => flavor.id === additionalFlavor.id,
          );

          if (!flavorMeta) {
            return null;
          }

          return {
            ...flavorMeta,
            count: Number(additionalFlavor.count) || 0,
          };
        })
        .filter((flavor) => flavor && flavor.count > 0);

      if (this.flavorMode === "sachets") {
        const additionalShakerUnits = [];
        selectedAdditionalShakers.forEach((flavor) => {
          const count = Number(flavor.count) || 0;
          for (let i = 0; i < count; i += 1) {
            additionalShakerUnits.push(String(flavor.itemId));
          }
        });

        const bundleSize = 3;
        const threeForTenVariantId = "58275393175939";
        const bundleCount = Math.floor(
          additionalShakerUnits.length / bundleSize,
        );
        const bundledUnits = additionalShakerUnits.slice(
          0,
          bundleCount * bundleSize,
        );
        const singles = additionalShakerUnits.slice(bundleCount * bundleSize);

        const bundledCountsByVariant = bundledUnits.reduce((acc, variantId) => {
          acc[variantId] = (acc[variantId] || 0) + 1;
          return acc;
        }, {});

        const bundledShakerNames = selectedAdditionalShakers
          .map((flavor) => {
            const count = bundledCountsByVariant[String(flavor.itemId)] || 0;
            return count > 0 ? `${count} ${flavor.name}` : null;
          })
          .filter(Boolean);

        if (bundleCount > 0) {
          items.push({
            id: threeForTenVariantId,
            quantity: bundleCount,
            properties: {
              Shakers: bundledShakerNames.length
                ? bundledShakerNames.join(", ")
                : "None",
            },
          });
        }

        const singleCountsByVariant = singles.reduce((acc, variantId) => {
          acc[variantId] = (acc[variantId] || 0) + 1;
          return acc;
        }, {});

        Object.entries(singleCountsByVariant).forEach(
          ([variantId, quantity]) => {
            items.push({ id: variantId, quantity });
          },
        );
      }

      this.cartLoading = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      }).then((response) => {
        if (response.ok) {
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:open", {
              bubbles: true,
            }),
          );
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true,
            }),
          );

          this.cartLoading = false;
          this.step = 6;
          this.updateState();
          this.init();
          document.querySelector(".crisp-kit").classList.remove("crisp-kit");
          document.querySelector(".crips-kit-nav").style.display = "none";
          document
            .querySelector(".crisp-kit-full")
            .classList.remove("crisp-kit-full");
          document.body.classList.remove("fixed");
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
          this.clearPersistedState();
          history.pushState({}, "");
        } else {
          console.error("Error adding to cart:", response.statusText);
        }
      });
    },
  };
}
